export const MuiSelect = {
  defaultProps: {
    MenuProps: {
      anchorOrigin: {
        vertical: 'bottom' as const,
        horizontal: 'left' as const,
      },
      transformOrigin: {
        vertical: 'top' as const,
        horizontal: 'left' as const,
      },
      PaperProps: {
        style: {
          maxHeight: 200,
          marginTop: 4,
        },
      },
      MenuListProps: {
        style: {
          paddingTop: 2,
          paddingBottom: 2,
        },
      },
    },
  },
  styleOverrides: {
    icon: {
      right: 12,
    },
    select: {
      paddingRight: '32px !important',
    },
  },
};
